import {
    Button,
    CardActions,
    CircularProgress,
    Dialog, DialogActions,
    DialogContent, DialogContentText, DialogTitle,
    Grid, IconButton, List, ListItem,
    ListItemIcon,
    ListItemSecondaryAction,
    ListItemText,
    ListSubheader, Paper,
    TextField, Typography, makeStyles
} from "@material-ui/core";
import { Add, Delete, DragIndicator, Save, Shuffle } from "@material-ui/icons";
import { random } from "lodash";
import { useEffect, useState } from "react";
import { useNotify, useRedirect } from "react-admin";

import { DndContext, DragOverlay, MouseSensor, useDraggable, useDroppable, useSensor, useSensors } from "@dnd-kit/core";
import ExpandableCard from "../../components/expandable-card";
import dataProvider from "../../providers/data-provider";

const useStyles = makeStyles((theme) => ({
    grid: {

    },
    rowContainer: {
        flexDirection: 'row',
    },

    columnContainer: {
        flexDirection: 'column',
    },

    studentListItem: {
        marginBlock: '4px',
        background: theme.palette.primary.dark,
        borderRadius: '16px',
        overflowX: 'hidden',
    },

    titleHeader: {
        textAlign: 'right',
        backgroundColor: theme.palette.primary.main,
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px',
        margin: '-8px 8px -8px -16px',
        flexBasis: '15%'
    },

    titleText: {
        flexBasis: 'content',
        alignSelf: 'center',
        flexGrow: 1,
        marginRight: '-16px'
    },

    title: {
        fontWeight: 'bold',

    },

    body: {
        flexDirection: 'row',
    },

    paper: {
        padding: '8px 16px 8px 16px',
        marginTop: '8px',
        marginBottom: '8px'
    },

    listHeader: {
        width: '100%',
        marginLeft: '-16px',
        paddingLeft: '16px',
        marginRight: '-16px',
        paddingRight: '16px',
        borderBottom: '1px solid #8c8989',
        marginBottom: '8px',
        backgroundColor: theme.palette.primary.main,
        marginTop: '-8px',
        borderTopRightRadius: '4px',
        borderTopLeftRadius: '4px',
        paddingBlock: '4px',
    },

    teamList: {
        overflowY: 'scroll',
        overflowX: 'hidden',
        maxHeight: '55vh',
        height: '55vh',
        width: '100%',
        alignContent: 'flex-start',
        paddingRight: '8px',
        listStyleType: 'none',
    },

    teamCard: {
        justifyContent: 'space-evenly',
        backgroundColor: theme.palette.background.default,
        marginBlock: '4px'
    },

    teamParties: {
        flexBasis: '45%',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '8px',
    },

    teamDrag: {
        flexBasis: '45%',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '8px',
        border: '1px dotted red'
    },

    teamEmpty: {
        flexBasis: '45%',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '8px',
        border: '1px solid red'
    },

}))

const sortByName = (a, b) => a.user.name > b.user.name ? 1 : -1;



const DraggableStudent = ({ student }) => {

    const classes = useStyles();

    const { attributes, listeners, setNodeRef, transform } = useDraggable({
        id: student.id,
        data: { name: student.user.name }
    });
    const style = transform ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`
    } : undefined;

    return (
        <ListItem ref={setNodeRef} dense key={`student${student.id}`} style={style} className={classes.studentListItem} {...attributes} {...listeners}>
            <ListItemIcon>
                <DragIndicator />
            </ListItemIcon>
            <ListItemText primary={student?.user?.name} />
        </ListItem>
    )
}

const Header = ({ school_activity, generateRandomDist }) => {

    const classes = useStyles()
    const [dialogOpen, setDialogOpen] = useState(false)
    const [val, setVal] = useState(0)

    const openDialog = () => {
        setDialogOpen(true)
    }

    const closeDialog = () => {
        setVal(1)
        setDialogOpen(false)
    }

    const handleValChange = (e) => e.target.value > 0 && setVal(e.target.value)

    return (
        <Grid container item className={classes.rowContainer}>
            <Grid container item className={classes.columnContainer} style={{ flexShrink: 1, flexBasis: '70%' }}>
                <Paper elevation={1} className={classes.paper}>
                    <Grid container style={{ padding: '0px' }}>
                        <Grid container className={classes.titleHeader} item spacing={2} direction="column">
                            <Grid item style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.12)' }}><Typography className={classes.title} color="textPrimary"> Atividade: </Typography> </Grid>
                            <Grid item><Typography className={classes.title} color="textPrimary"> Turma: </Typography></Grid>
                        </Grid>
                        <Grid container className={classes.titleText} item spacing={2} direction="column">
                            <Grid item style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.12)' }}><Typography color="textPrimary"> {school_activity?.name} </Typography> </Grid>
                            <Grid item><Typography color="textPrimary"> {school_activity?.class?.name} </Typography></Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
            <Grid container item className={classes.rowContainer} style={{ flexGrow: 1, flexBasis: '20%', justifyContent: 'flex-end' }}>
                <Button onClick={openDialog} startIcon={<Shuffle />} variant="contained" size="medium" color="secondary" style={{ alignSelf: 'center' }}> Gerar distribuição aleatória </Button>
                <Dialog
                    open={dialogOpen}
                    onClose={closeDialog}
                >
                    <DialogTitle>Gerar distribuição aleatória</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Ao gerar a distribuição aleatória, os alunos da turma serão distribuídos em grupos de maneira automática, respeitando o parâmetro abaixo.
                        </DialogContentText>
                        <TextField type="number" label="Alunos por parte" value={val} onChange={handleValChange} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Cancelar</Button>
                        <Button onClick={() => { generateRandomDist(val); closeDialog() }}>OK</Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        </Grid>
    )
}


const StudentList = ({ students }) => {
    const classes = useStyles()

    return (
        <Grid item container key={'students'} className={classes.columnContainer} style={{ flexShrink: 1, flexBasis: '25%', height: '70vh', maxHeight: '70vh' }}>
            <Paper elevation={1} className={classes.paper}>
                <div className={classes.listHeader}>
                    <Typography className={classes.title}>Alunos disponíveis ({students?.length})</Typography>
                </div>
                <div className={classes.teamList}>
                    {students && students.length > 0 && students.map((student, idx) =>
                        <DraggableStudent key={`student-list-${student.id}`} student={student} />
                    )}
                </div>
            </Paper>
        </Grid>
    )
}

const CreateActivityTeams = ({ ...props }) => {

    const id = props.match.params.id;
    const classes = useStyles()
    const redirect = useRedirect()
    const notify = useNotify()

    const [teams, setTeams] = useState([]);
    const [students, setStudents] = useState(null);
    const [school_activity, setSchoolActivity] = useState(null)
    const [parties, setParties] = useState(null);
    const [errors, setErrors] = useState(true);
    const [loading, setLoading] = useState(false);
    const [active, setActive] = useState(null);

    const sensors = useSensors(
        useSensor(MouseSensor, {
            activationConstraint: {
                distance: 8,
            },
        }),)

    useEffect(() => {
        const fetchData = async () => await dataProvider.get('school-activities', `${id}/teamCreator`)
        fetchData().then(res => {
            const newStudents = res.data?.class?.user_contexts
            setStudents(newStudents.sort(sortByName))
            setParties(res.data.party_types)
            setSchoolActivity(res.data)
        })
    }, [id])

    useEffect(() => {
        let hasError = true
        const rolesWithoutUsers = teams.filter(team => team.parties.filter(party => party.students.length === 0).length > 0)
        if (teams.length > 0 && rolesWithoutUsers.length === 0) { hasError = false }
        setErrors(hasError)
    }, [teams, students])

    const submitTeams = async () => {
        setLoading(true)
        dataProvider.post('school-activities', 'create-teams', { activity: id, teams })
            .then(() => {
                notify('Processos criados com sucesso', 'success')
                redirect(`/school-activity-dashboard/${id}`)
            }).catch((error) => {
                notify('Erro ao criar os processos.', 'error')
            }).finally(() => {
                setLoading(false)
            })
    }

    const generateRandomDist = (val) => {
        const newTeams = [...teams]
        const studentsPerParty = val
        const qtParties = parties.length
        let teamsAmount = parseInt(students.length / (studentsPerParty * qtParties))
        const rest = students.length % (studentsPerParty * qtParties)
        const newStudents = students
        const nextId = newTeams.length > 0 ? newTeams[newTeams.length - 1].id + 1 : 1
        const generatedTeams = []
        if (rest > 0) teamsAmount += 1;
        for (let i = 0; i < teamsAmount; i++) {
            let team = { id: i + nextId, name: `Processo ${(i + nextId).toString().padStart(2, "0")}`, students: [], parties: parties.map((party) => ({ id: party.id, name: party.name, students: [] })) }
            for (let j = 0; j < studentsPerParty; j++) {
                for (let k = 0; k < qtParties; k++) {
                    let randIndex = random(0, newStudents.length - 1, false)
                    let s = newStudents.splice(randIndex, 1)
                    team.students.push(...s)
                    team.parties[k].students.push(...s)
                }
            }

            generatedTeams.push(team)
        }
        setTeams([...newTeams, ...generatedTeams])
    }

    const addTeam = () => {
        if (teams?.length > 0) {
            const id = teams.slice(-1)[0].id + 1
            setTeams([...teams, { id: id, name: `Processo ${(id).toString().padStart(2, "0")}`, students: [], parties: parties.map((party) => ({ id: party.id, name: party.name, students: [] })) }])
        } else {
            setTeams([{ id: 1, name: 'Processo 01', students: [], parties: parties.map((party) => ({ id: party.id, name: party.name, students: [] })) }])
        }
    }

    const removeTeam = (id) => {
        const team = teams.find(team => team.id === id)
        setStudents([...students, ...team.students].sort(sortByName))
        setTeams(teams.filter(team => team.id !== id))
        setActive(null)
    }

    const addStudentToParty = (studentId, teamId, partyId) => {
        const newTeams = [...teams]
        const stateStudents = [...students]
        const [student] = stateStudents.splice(stateStudents.findIndex(student => student.id === studentId), 1)
        const teamidx = teams.findIndex(t => t.id === teamId)
        const partyidx = teams[teamidx].parties.findIndex(party => party.id === partyId)
        newTeams[teamidx].students.push(student)
        newTeams[teamidx].parties[partyidx].students.push(student)
        setTeams(newTeams)
        setStudents(stateStudents.sort(sortByName))
    }

    const removeStudentFromTeam = (teamId, studentId, partyId) => {
        let newTeams = [...teams]

        const team = newTeams.find(team => team.id === teamId)
        const party = team.parties.find(party => party.id === partyId)
        team.students.splice(team.students.findIndex(student => student.id === studentId), 1)
        const [student] = party.students.splice(party.students.findIndex(student => student.id === studentId), 1)
        setStudents([...students, student].sort(sortByName))
        setTeams(newTeams)
    }

    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (over) {
            addStudentToParty(active.id, over.data.current.team, over.data.current.party)
        }
        setActive(null)

    }

    function handleDragStart(event) {
        setActive({ id: event.active.id, name: event.active.data.current.name });
    }

    return (
        <Grid container className={classes.columnContainer}>
            <Header school_activity={school_activity} generateRandomDist={generateRandomDist} />
            <Grid container item className={classes.body} spacing={2}>
                <DndContext sensors={sensors} onDragEnd={handleDragEnd} onDragStart={handleDragStart}>
                    <StudentList students={students} />
                    <TeamsList teams={teams} addTeam={addTeam} removeTeam={removeTeam} removeStudent={removeStudentFromTeam} />
                    <DragOverlay>
                        {active ? (
                            <ListItem dense className={classes.studentListItem}>
                                <ListItemIcon>
                                    <DragIndicator />
                                </ListItemIcon>
                                <ListItemText primary={active.name} />
                            </ListItem>
                        ) : null}
                    </DragOverlay>
                </DndContext>
            </Grid>
            <CreateActivityTeamsToolbar id={id} students={students} errors={errors} submitTeams={submitTeams} loading={loading} />
        </Grid>
    )
}

const TeamsList = ({ teams, addTeam, removeTeam, removeStudent }) => {
    const classes = useStyles();

    return (
        <Grid item container key={'teams'} className={classes.columnContainer} style={{ flexGrow: 1, flexBasis: '70%', height: '70vh', maxHeight: '70vh' }}>
            <Paper elevation={1} className={classes.paper}>
                <div className={classes.listHeader}>
                    <Grid item container key={'team-controls'} className={classes.rowContainer} style={{ alignItems: 'center', maxHeight: '24px' }}>
                        <img alt='processos' src={'https://game-juridico.s3.sa-east-1.amazonaws.com/assets/pictograma_EQUIPES.png'} width={'50px'} height={'50px'} style={{ opacity: '0.5', margin: '-12px', marginRight: '8px' }} />
                        <Typography className={classes.listTitle}>Processos ({teams?.length})</Typography>
                        <span style={{ flexGrow: 1 }} />
                        <IconButton size="small" onClick={() => addTeam()}><Add /></IconButton>
                    </Grid>
                </div>
                <Grid item container key={'team-data'}>
                    <div className={classes.teamList}>
                        {teams && teams.length > 0 && teams.map((team) => (
                            <Team data={team}
                                removeTeam={removeTeam}
                                removeStudent={removeStudent}
                            />
                        ))}
                    </div>
                </Grid>
            </Paper>
        </Grid>
    )
}

const DroppablePartyList = ({ team, party, removeStudent }) => {
    const classes = useStyles()

    const { isOver, setNodeRef } = useDroppable({
        id: `${team.id}/${party.id}`,
        data: { team: team.id, party: party.id }
    });

    return (
        <List ref={setNodeRef}
            className={(party.students && party.students.length > 0) ? classes.teamParties : isOver ? classes.teamDrag : classes.teamEmpty}
            style={{ paddingTop: '4px', marginInline: '4px' }} dense
            subheader={
                <ListSubheader style={{ lineHeight: '32px', borderBottom: '1px solid rgba(255, 255, 255, 0.12)' }}>
                    {party.name}
                </ListSubheader>
            }
        >
            {(!party?.students || party?.students?.length === 0) && (
                <ListItem dense>
                    <ListItemText primary={'Sem representante - Arraste um aluno sobre esta área para adicionar'} />
                </ListItem>
            )}

            {party?.students?.map(student => (

                <ListItem dense key={`student${student.id}`}>
                    <ListItemText primary={student?.user?.name} />
                    <ListItemSecondaryAction>
                        <IconButton onClick={() => removeStudent(team.id, student.id, party.id)}><Delete /></IconButton>
                    </ListItemSecondaryAction>

                </ListItem>
            ))}

        </List>
    )
}

const Team = ({ data, removeTeam, removeStudent, addStudentToParty }) => {

    const classes = useStyles()

    return (
        <ExpandableCard className={classes.teamCard} outlined title={data.name}>
            <Grid container>
                {data.parties.map(party => <DroppablePartyList team={data} party={party} addStudentToParty={addStudentToParty} removeStudent={removeStudent} />)}
            </Grid>
            <CardActions>
                <div style={{ flexGrow: 1 }}></div>
                <Button size="small" style={{ marginBottom: '-20px', marginRight: '-15px' }} variant="outlined" onClick={() => removeTeam(data.id)} startIcon={<Delete />}>Remover processo</Button>
            </CardActions>
        </ExpandableCard>
    )
}

const CreateActivityTeamsToolbar = ({ id, students, errors, submitTeams, loading }) => {
    const classes = useStyles();
    const redirect = useRedirect();

    const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);

    const handleConfirmationDialogOpen = () => setConfirmationDialogOpen(true)
    const handleConfirmationDialogClose = () => setConfirmationDialogOpen(false)

    return (
        <Grid container item className={classes.rowContainer}>
            <Button onClick={() => redirect(`/school-activity-dashboard/${id}`)} color="secondary" variant="contained" disabled={loading} >Cancelar</Button>
            <span style={{ flexGrow: 1 }} />
            <Button onClick={students?.length > 0 ? handleConfirmationDialogOpen : submitTeams} variant="contained" disabled={errors || loading} color="primary" startIcon={loading ? <CircularProgress size={16} /> : <Save />}>Salvar</Button>
            <Dialog
                open={confirmationDialogOpen}
                onClose={handleConfirmationDialogClose}
            >
                <DialogTitle>Ainda existem {students?.length} alunos disponíveis!</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Deseja prosseguir com a criação da atividade sem alocar todos os alunos disponíveis nesta turma?
                    </DialogContentText>
                    <DialogContentText>
                        Esta distribuição de alunos não poderá ser editada posteriormente.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmationDialogClose}>Cancelar</Button>
                    <Button onClick={() => { submitTeams(); handleConfirmationDialogClose() }}>OK</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}
export default CreateActivityTeams;